import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { updateMcpConnectorSettings } from '@/services/mcp-gateway';

export function useUpdateMcpConnectorSettings() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: ({ connectorId, readOnly }: { connectorId: string; readOnly: boolean }) =>
      updateMcpConnectorSettings(connectorId, { read_only: readOnly }, orgId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['mcp-connectors', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['mcp-connector-tools', orgId] });
    },
  });
}
